import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const HouseIcon = (props) => (
    <SvgIcon {...props}>
        <path d="M9.6,22.2V15h4.8v7.2h6v-9.6H24L12,1.8L0,12.6h3.6v9.6H9.6z"/>
    </SvgIcon>
);

export default HouseIcon;